import React from 'react'
import './TermsAndConditionsContent.css'

const TermsAndConditionsContent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <div className="terms-content">{children}</div>
}

export default TermsAndConditionsContent
